module.exports = __webpack_public_path__ + "HP_Latex_700-800_textile_printing.jpg?ca34362e49dbfb5a77218e13a32922ca";